export default {
  en: {
    translation: {
      common: {
        cancel: "Cancel",
        save: "Save",
      },
      checkinApp: {
        addSeatNote: "Add Seat Note",
        addCustomerNote: "Add Customer Note",
        addSeatFeedback: "Add Seat Feedback",
        addLoungePreferences: "In Lounge Preferences",
        noteEditor: {
          heading: "Edit Note",
          placeholder: "type note here...",
        },
        loungePreferencesEditor: {
          heading: "Edit Lounge Preferences",
          placeholder: "type lounge preferences here...",
        },
        seatFeedback: {
          editor: {
            heading: "Edit Seat Feedback",
            note_html:
              '<b>Note:</b> For this flight only. Use "Customer Notes" to appear on future flights.',
            placeholder:
              "Why this airport, time, flight, one-way, round-trip?     Did this chedule flight time work for you?     Did you know about Ground Connect?     First time flyer?     How did you hear about us?     How was your booking experience?",
          },
          text: {
            heading: "Seat Feedback:",
            edit: "Edit",
          },
        },
      },
      salespersonTypeahead: {
        label: "Salesperson",
        placeholder: "Add Salesperson",
      },
      addDiscountModal: {
        title: "Add Discount",
        price: {
          label: "Price:",
        },
        qty: {
          label: "Qty:",
        },
        discount: {
          label: "Discount:",
        },
        taxes: {
          label: "Taxes:",
        },
        total: {
          label: "Total:",
        },
        discountAmountPreTax: {
          label: "Discount Amount",
          errors: {
            required: "Discount is required.",
            negative: "Discount cannot be negative.",
            moreThanItemTotal: "Discount cannot be more than item total.",
            moreThanGrossAmount:
              "Discount cannot be more than gross amount(list price x quantity).",
          },
        },
        totalIncludingDiscount: {
          label: "Total including discount:",
        },
        reason: {
          label: "Reason",
          select: "Select a discount reason",
          errors: {
            required: "Reason is required.",
          },
        },
        discountDescription: {
          label: "Discount Description",
          info: "Visible to customers on invoice and confirmation email.",
          errors: {
            required: "Description is required.",
          },
        },
        notes: {
          label: "Notes",
          info: "Internal notes for order history.",
          errors: {
            required: "Notes is required.",
            minimumNotesCharacters:
              "Notes must have a minimum of 10 characters.",
          },
        },
        reasonWarning: {
          line1:
            "Are you sure this is an exception discount and not another discount type or a credit memo?",
          line2:
            "For example, if you are balancing a charter order, use a credit memo instead of a discount",
        },
      },
      productSearch: {
        enterOrigin: "Enter Origin",
        enterDestination: "Enter Destination",
        searchFlights: "Search Flights",
        passengers: "Passengers",
        getNotified: "Get notified when new flights are added to this route",
        next: "Next",
        searchAll: "Search All",
        origin: "Origin",
        destination: "Destination"
      },
      originSearch: {
        suggestedCharter: "Charter, Crowdsource to ",
        suggested: "Suggested",
        label: "Where Are You Flying From?",
        placeholder: "Search All Origins",
        origins: "Origins"
      },
      destinationSearch: {
        suggestedCharter: "Charter, Crowdsource from ",
        suggested: "Suggested",
        label: "Where do you want to fly?",
        placeholder: "Search All Destinations",
        destinations: "Destinations"
      },
      stationSearchResults: {
        loading: "Loading...",
        error: "Sorry, an error occurred. Please try again later.",
        no_matches: "No matches.",
        all: "All"
      },
      flightSearch: {
        selectReturnDate: "Select a Return Date"
      }
    },
  },
};
